import { render, staticRenderFns } from "./Create-Invoice.vue?vue&type=template&id=c5f87428&scoped=true"
import script from "./Create-Invoice.vue?vue&type=script&lang=js"
export * from "./Create-Invoice.vue?vue&type=script&lang=js"
import style0 from "./Create-Invoice.vue?vue&type=style&index=0&id=c5f87428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f87428",
  null
  
)

export default component.exports